import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../shared/user.service';
import { Search } from '../../shared/user.model';
import swal from 'sweetalert2';

@Component({
  selector: 'fir-grid',
  templateUrl: './fir-grid.component.html',
  styleUrls: ['./fir-grid.component.css']
})
export class FirGridComponent implements OnInit {
  itemsPerPage: number=5;
  currentPage: number=1;
 FirDetailsList : any = {};
  data : any = {};  
  totalItems : number;
  s: Search;
  isSearch:boolean = false;
  Fir_id : number;

  title="FIR";

  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
     this.s = new Search();
    this.isSearch = false;
   }

   ngOnInit() { 
    this.GetFirDetails(this.itemsPerPage, 1)
  }
  GetFirDetails(itemsPerPage:any,pageNo:any){
    debugger;
    //alert('Inside');
    this.isSearch = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.UserService.GetFirDetails(itemsPerPage,pageNo);
      this.data.subscribe(
        (response: any) => {
          this.FirDetailsList = response.FirModel;
            this.totalItems = response.TotalItemsCount;
            this.itemsPerPage = itemsPerPage;
            this.currentPage = pageNo;  
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    } pageChanged(pageNumber: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNumber);
      else
        this.GetFirDetails(this.itemsPerPage, pageNumber);
    }
  
    itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNo);
      else
        this.GetFirDetails(this.itemsPerPage, pageNo);
    }


  //Search item


  onSearch(s, itemsPerPage: number, pageNo: number) {   
    this.isSearch = true;
    let searchText = this.s.SearchText;
    let searchCriteria = this.s.SearchCriteria;
    if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
      swal("Warning!", "Please enter the search criteria and search text.", "warning");
    else {
      document.getElementById('loader-spinner').style.display = "block";
      this.UserService.SearchFir(searchCriteria, searchText, itemsPerPage, pageNo)
        .subscribe(
          (data: any) => {
            if(data.FirModel.length!=0){              
            this.FirDetailsList = data.FirModel;
            this.totalItems = data.TotalItemsCount;
            this.currentPage = pageNo;
            document.getElementById('loader-spinner').style.display = "none";
          }
          else
          {
          document.getElementById('loader-spinner').style.display = "none";         
          }
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
    }
  }
  delete(Fir_id){
    swal({
         title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
        this.data = this.UserService.DeleteFir(Fir_id);
        this.data.subscribe(
         (response: any) => {
             this. GetFirDetails(this.itemsPerPage, 1)          
         },(error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        }       
      ); 
    } 
    })
    }


}



// WEBPACK FOOTER //
// ./src/app/FIR/fir-grid/fir-grid.component.ts